import React from "react"
import { Backdrop, CircularProgress, Typography, Box } from "@mui/material"

export function CustomBackdrop({ open, text }) {
  return (
    <div>
        <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1300,
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            }}
            open={open}
          >
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
              <CircularProgress color="inherit" size={60} />
              <Typography variant="h6" sx={{ fontFamily: '"DM Sans", sans-serif' }}>
                    {text}
              </Typography>
            </Box>
          </Backdrop>
    </div>
  )
}

export default CustomBackdrop;
